import React from 'react';
import { usePredefined } from '../../../Data/Services';
import { PageLoading } from '../../../Components/Loading';
import { useOnboarding } from '../OnboardingProvider';
import Icon from '../../../Components/Icons/Icon';
import StepShell, { StepActions } from '../Components/StepShell';
import WizardServices from '../Components/WizardServices';

const ServicesStep = () => {
    const {draft, updateStepData, next} = useOnboarding();
    const {predefined} = usePredefined();

    const value = draft.data.services;
    const canContinue = (value?.selected?.length ?? 0) > 0;

    return <StepShell
        title="What services do you offer?"
        intro="You can add more and fine-tune the details later."
    >
        {!predefined && <PageLoading />}

        {predefined && <>
            <WizardServices
                value={value}
                onChange={(v) => updateStepData('services', v)}
                predefined={predefined}
            />

            <StepActions>
                <div className="flex justify-end">
                    <button
                        type="button"
                        className="my-3 btn btn-primary"
                        disabled={!canContinue}
                        onClick={next}
                    >
                        <span className="flex items-center gap-x-2">Next <Icon icon="ArrowRight" /></span>
                    </button>
                </div>
            </StepActions>
        </>}
    </StepShell>;
};

export default ServicesStep;
